import React from "react";
import { Navigate } from "react-router-dom";

import authStorage from 'providers/authStorage.js';
import { canByDepartments, canByRoles } from "utils/permissions.js";

const SmartRoute = ({ layout, layoutProps, accessRoles = [], accessDepts = [], element }) => {
  const renderComponent = layout
    ? React.createElement(layout, layoutProps, element)
    : element;

  if (authStorage.getAccess()) {
    const hasAccess = canByRoles(accessRoles) && canByDepartments(accessDepts);
    return hasAccess ? renderComponent : <Navigate to="/403" replace />;
  } else {
    return <Navigate to="/login" replace />;
  }
};

export default SmartRoute;
